import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import constants from '@/utils/constants';
import { removeData } from '@/data/cache';

interface IMetaDetails {
	otpToken: string;
	organisationId: string;
	metaId: string;
}
export interface TAuthStore {
	reset: () => void;
	setMetaDetails: (metaDetails: IMetaDetails) => void;
	metaDetails?: IMetaDetails;
	isLoggedIn: boolean;
	setLoginDetails: (isLoggedIn: boolean) => void;
	setVendorLayoutLoaded: (isVendorLayoutLoaded: boolean) => void;
	isVendorLayoutLoaded: boolean;
	logout: () => void;
}

const initialState = {
	metaDetails: {
		otpToken: '',
		organisationId: '',
		metaId: '',
	},
	isLoggedIn: false,
	isVendorLayoutLoaded: false,
};
export const useAuthStore = create<TAuthStore>()(
	persist(
		(set, get) => ({
			...initialState,
			reset: () => set({ ...initialState }),
			setMetaDetails: (metaDetails: IMetaDetails) =>
				set((state) => ({
					...state,
					metaDetails,
				})),
			setLoginDetails: (isLoggedIn: boolean) =>
				set((state) => ({
					...state,
					isLoggedIn,
				})),
			setVendorLayoutLoaded: (isVendorLayoutLoaded: boolean) =>
				set((state) => ({
					...state,
					isVendorLayoutLoaded,
				})),
			logout: () => {
				get().reset();
				removeData(constants.VENDOR_AUTH);
			},
		}),
		{
			name: constants.VENDOR_AUTH,
			storage: createJSONStorage(() => localStorage),
		},
	),
);
